import React from 'react';

import { Card, FormItem, Toggle } from '../../../components';
import { Input } from '../../../components/Input';
import type { AgentForm as AgentFormType } from '../../../utilities';

export type SlackAlertsSettingsProps = {
  disabled?: boolean;
  form: AgentFormType;
};

export const SlackAlertsSettings: React.FC<SlackAlertsSettingsProps> = ({
  disabled,
  form,
}) => {
  return (
    <Card
      collapsable
      size="unset"
      title="Alerts and Monitoring"
      name="agentpage.alertsAndMonitoring"
      contentClassName="flex flex-col gap-y-md"
      subtitle="Configure Slack alerts for pipeline errors and monitoring events"
    >
      <FormItem<AgentFormType>
        name="slack_alerts_config_enabled"
        label="Enable Slack alerts"
        className="flex justify-between items-center"
      >
        <Toggle disabled={disabled} />
      </FormItem>
      {form.slack_alerts_config_enabled && (
        <>
          <FormItem<AgentFormType>
            name="slack_alerts_config_channel_id"
            label="Slack channel ID"
            tooltip="Slack channel ID where alerts will be posted (e.g. C123)"
          >
            <Input disabled={disabled} />
          </FormItem>
          <FormItem<AgentFormType>
            name="slack_alerts_config_exclude_regex"
            label={
              <div className="flex flex-col">
                <span>Exclude regex patterns</span>
                <span className="text-tiny text-gray-500">
                  One pattern per line
                </span>
              </div>
            }
          >
            <Input multiline disabled={disabled} />
          </FormItem>
        </>
      )}
    </Card>
  );
};
